
    import { Options, Vue } from 'vue-class-component';

    @Options<ApToggle>({
        props: {
            modelValue: {
                type: Boolean,
                default: false,
            },
            allowed: {
                type: Boolean,
                default: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            inverseColors: {
                type: Boolean,
                default: false,
            },
            trueColor: {
                type: String,
                default: '#2D9B74',
            },
            falseColor: {
                type: String,
                default: '#d6d6dc',
            },
            xColor: {
                type: String,
                default: '#FF4242',
            },
            confirmFn: {
                type: Function,
                default: undefined,
            },
            warningLabel: {
                type: String,
                default: undefined,
            },
        },
    })
    export default class ApToggle extends Vue {
        public modelValue!: boolean;
        public allowed!: boolean;
        public disabled!: boolean;
        public inverseColors!: boolean;
        public warningLabel: string | undefined;

        public confirmFn: ((newVal: boolean) => Promise<boolean>) | undefined;

        public trueColor: string | undefined;
        public falseColor: string | undefined;
        public xColor: string | undefined;

        onChange(newVal: boolean) {
            this.$emit('update:modelValue', newVal);
            this.$emit('input', newVal);
        }

        get getIconClass() {
            return this.modelValue ? 'ap-icon-check' : 'ap-icon-x';
        }

        get getSliderStyleColor(): string | undefined {
            let val = this.modelValue;
            if (this.inverseColors) {
                val = !val;
            }
            if (val) {
                return this.trueColor;
            } else {
                return this.allowed ? this.falseColor : this.xColor;
            }
        }

        get getSliderStyle(): object {
            return { 'background-color': this.getSliderStyleColor };
        }

        async labelOnClick() {
            if (this.disabled) {
                return;
            }
            const newVal = !this.modelValue;
            if (this.confirmFn) {
                const ret = await this.confirmFn(newVal);
                if (!ret) {
                    return;
                }
            }

            this.onChange(newVal);
        }
    }
